// Ctrl+K, or ⌘K on a Mac: the shortcut that opens the sedes of a partner,
// wherever the screen keeps them (the profile menu, the overview's switcher).
// AltGr reports Ctrl+Alt, so a "k" typed with a modifier of its own is left
// alone.
export const isSedeSearchShortcut = (event) =>
  (event.ctrlKey || event.metaKey) &&
  !event.altKey &&
  !event.shiftKey &&
  String(event.key).toLowerCase() === "k";
